/**
 * @desc 新品下单-保存并提交工作流
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductOrderResponseDto>;
export function request(
  body: defs.basics.ProductOrderRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productOrder/saveAndCommit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
